import styled from "@emotion/styled";

export const ContentSection = styled.div`
    width: 100%;
    min-height: 100%; /* ensures it expands even when parent has auto-height */
    flex: 1; /* ensures it grows inside flex parents */
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    gap: 24px;
`;

export const Heading = styled.div`
    font-family: Custora;
    font-weight: 400;
    font-style: Regular;
    font-size: 32px;
    leading-trim: NONE;
    line-height: 40px;
    letter-spacing: 0px;
    text-align: center;
    vertical-align: middle;
    color: #e9ecf5;
`;
export const SubHeading = styled.div`
    font-family: Inter;
    font-weight: 400;
    font-style: Regular;
    font-size: 16px;
    leading-trim: NONE;
    line-height: 150%;
    letter-spacing: 0px;
    text-align: center;
    vertical-align: middle;
    color: #b7bdcb;
    max-width: 301px;
`;

export const ButtonsContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
    gap: 24px;
`;

export const InputsContainer = styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 24px;
`;

export const CenterColumn = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
`;

export const SmsConsentRow = styled.div`
    margin-top: 16px;
    width: 100%;
    display: flex;
    gap: 8px;
    align-items: flex-start;
`;

export const SmsConsentCheckbox = styled.input`
    display: flex;
    justify-content: center;
    align-items: center;
    width: 22px;
    height: 22px;
    margin-top: 2px;
    flex: 0 0 auto;
    accent-color: #5e84ed;

    /* Remove native checkbox styling */
    appearance: none;
    -webkit-appearance: none;
    -moz-appearance: none;

    background-color: transparent;
    border: 2px solid #5e84ed;
    border-radius: 4px;
    cursor: pointer;

    /* Custom checked state */
    &:checked {
        background-color: #5e84ed;
        border-color: #5e84ed;
    }

    /* Optional: add a checkmark */
    &:checked::after {
        content: "✔";
        color: white;
        font-size: 16px;
    }
`;

export const SmsConsentLabel = styled.label`
    font-size: 12px;
    line-height: 1.45;
    cursor: pointer;
    font-family: "Inter", sans-serif;
    color: #b7bdcbcc;
`;

export const StyledLink = styled.a`
    color: #5e84ed;
    text-decoration: underline;
`;

export const SmsConsentError = styled.div`
    color: #d64545;
    font-size: 12px;
    margin-top: 6px;
`;
